"use client";

import { cn } from "@/lib/utils";
import StockIndicator from "@app/_components/Stock/statuses/StockIndicator";
import { StockStatusEnum } from "@app/_components/Stock/Stock.types";
import { Dialog } from "@app/_components/ui";
import useTranslate from "@app/_hooks/useTranslate";
import { ComponentProps, useState } from "react";
import StoreLocatorList, { StoreWithStock } from "./StoreLocatorList";

export default function StoreLocatorStatus({
  stores,
  className,
  ...props
}: ComponentProps<"div"> & { stores: Array<StoreWithStock> }) {
  const t = useTranslate();
  const [open, setOpen] = useState(false);

  const inStore = stores.some(
    (store) => typeof store.store === "number" && store.store > 0,
  );
  const inDisplay = stores.some(
    (store) => typeof store.display === "number" && store.display > 0,
  );
  const siblingsInStore = stores.some(
    (store) =>
      typeof store.storeSiblings === "number" && store.storeSiblings > 0,
  );
  const siblingsInDisplay = stores.some(
    (store) =>
      typeof store.displaySiblings === "number" && store.displaySiblings > 0,
  );

  const isAvailable =
    inStore || inDisplay || siblingsInStore || siblingsInDisplay;

  return (
    <>
      <div
        className={cn("inline-flex flex-wrap items-start gap-2", className)}
        {...props}
      >
        {isAvailable ? (
          <>
            <StockIndicator
              status={{
                code: StockStatusEnum.IN_STOCK_ITEM,
                quantity: Infinity,
                pretty: "",
              }}
            />
            <span>{t("availableInStore")}</span>
            <button
              className="underline"
              type="button"
              onClick={() => setOpen(true)}
            >
              {t("showAvailabilityInStore")}
            </button>
          </>
        ) : (
          <>
            <StockIndicator status={{ code: StockStatusEnum.UNKNOWN }} />
            <span>{t("unavailableInStore")}</span>
          </>
        )}
      </div>
      <Dialog.Root open={open} onClose={() => setOpen(false)}>
        <Dialog.Overlay className="z-40" />
        <Dialog.Content
          position="right"
          className="lg:max-w-md"
          onClose={() => setOpen(false)}
        >
          <Dialog.Header className="border-border border-b bg-transparent">
            <Dialog.Title>{t("stores")}</Dialog.Title>
          </Dialog.Header>
          <StoreLocatorList stores={stores} />
        </Dialog.Content>
      </Dialog.Root>
    </>
  );
}
